module.exports = __webpack_public_path__ + "img/contactsImgMob2x.png";